<template>
  <div class="organisation">
    <div class="input-group">
      <label>Organisations</label>
      <v-autocomplete
        :items="filteredOrganisations"
        v-model="organisation"
        :get-label="organisation => organisation ? organisation.name : ''"
        :auto-select-one-item="false"
        @change="addOrganisation">
      </v-autocomplete>
    </div>
    <div class="options">
      <button class="save" @click="addOrganisation(organisation)"><i class="far fa-save"></i>Save</button>
    </div>

  </div>
</template>

<script>
export default {
  name: 'AddOrganisationToUserForm',
  props: ["user"],
  components: {
  },
  data() {
    return {
      filteredOrganisations: this.$store.getters.organisations,
      selectedOrganisation: this.$store.getters.organisationById(this.user.organisation)
    }
  },
  computed: {
    organisation: {
      get() {
        return this.selectedOrganisation
      },
      set(organisation) {
        this.selectedOrganisation = organisation
      }
    },
  },
  methods: {
    addOrganisation () {
      this.user.organisation = this.selectedOrganisation.id
      this.$store.dispatch("updateUser", this.user)
    },
  }
}
</script>

<style lang="scss" scoped>
.options {
  .save {
    font-size: 12px;
  }
}

</style>